import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _TimeZoneOffsetMappin;
export var TimeZone;
(function (TimeZone) {
  TimeZone["kalt"] = "kalt";
  TimeZone["msk"] = "msk";
  TimeZone["samt"] = "samt";
  TimeZone["yekt"] = "yekt";
  TimeZone["omst"] = "omst";
  TimeZone["krat"] = "krat";
  TimeZone["irkt"] = "irkt";
  TimeZone["yakt"] = "yakt";
  TimeZone["vlat"] = "vlat";
  TimeZone["magt"] = "magt";
  TimeZone["pett"] = "pett";
})(TimeZone || (TimeZone = {}));
export var TimeZoneOffsetMapping = (_TimeZoneOffsetMappin = {}, _defineProperty(_TimeZoneOffsetMappin, TimeZone.kalt, -1), _defineProperty(_TimeZoneOffsetMappin, TimeZone.msk, 0), _defineProperty(_TimeZoneOffsetMappin, TimeZone.samt, 1), _defineProperty(_TimeZoneOffsetMappin, TimeZone.yekt, 2), _defineProperty(_TimeZoneOffsetMappin, TimeZone.omst, 3), _defineProperty(_TimeZoneOffsetMappin, TimeZone.krat, 4), _defineProperty(_TimeZoneOffsetMappin, TimeZone.irkt, 5), _defineProperty(_TimeZoneOffsetMappin, TimeZone.yakt, 6), _defineProperty(_TimeZoneOffsetMappin, TimeZone.vlat, 7), _defineProperty(_TimeZoneOffsetMappin, TimeZone.magt, 8), _defineProperty(_TimeZoneOffsetMappin, TimeZone.pett, 9), _TimeZoneOffsetMappin);